import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionProExp = props => {
  return (
    <Hoc>
      <CvItem date1="Nov 2015" date2="Apr 2016" imgSrc="rena.jpg">
        <CvItemDesc descBold="ReNa Design Studio" descNormal="Tehran, Iran" descComment="" />
        <CvItemDetail primary bold>
          Architect, Project Manager
        </CvItemDetail>
      </CvItem>

      <CvItem date1="Mar 2015" date2="Aug 2015" imgSrc="hooba-BW.jpg">
        <CvItemDesc descBold="Hooba Design Studio" descNormal="Tehran, Iran" descComment="" />
        <CvItemDetail primary bold>
          Architect, Project Manager
        </CvItemDetail>
      </CvItem>

      <CvItem date1="Jul 2014" date2="Sep 2014" imgSrc="Arsh 4d.png">
        <CvItemDesc descBold="Arsh [4D] Design Studio" descNormal="Tehran, Iran" descComment="" />
        <CvItemDetail primary bold>
          Design Assistant, 3D modeler and visualizer
        </CvItemDetail>
      </CvItem>
    </Hoc>
  );
};

export default cvSectionProExp;
